/**
 * @desc 列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.ProductMaterialModel>>;
export function request(
  body: defs.basics.ProductMaterialRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productMaterial/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
